import React, { useEffect } from 'react'
import ApiService from '../../../Services/user/service';
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
const Favoriteslist = () => {
    const userid = localStorage.getItem("user_id");
    const currency = localStorage.getItem("currentCurrency");
    const [favoriteList, setFavoriteList] = React.useState([]);

    const getFavoriteList = async () => {
        if (!userid) return;

        const payload = {
            userid: userid
        };

        try {
            let res;

            if (currency === "1") {
                res = await ApiService.getFavroritelistInr(payload);
            }

            else {
                res = await ApiService.getFavroritelist(payload);
            }

            if (res?.data?.data?.length > 0) {
               setFavoriteList(
  res.data.data.map(item => ({
    ...item,
    isFav: true,   // 🔥 yahi main fix hai
  }))
);

            } else {
                setFavoriteList([]);
            }
        } catch (error) {
            console.log("Favorite list error", error);
        }
    };

    useEffect(() => {
        getFavoriteList();
    }, [userid, currency]);


const updateFavState = (symbol, isFav) => {
  setFavoriteList(prev =>
    prev.map(item =>
      item.symbol_name === symbol
        ? { ...item, isFav }
        : item
    )
  );
};



   const handleFavorite = async (row) => {
  try {
    const payload = {
      userid: userid,
      symbolname: row.symbol_name,
      exch_seg: row.exch_seg,
    };

    if (row.isFav) {
      const res = await ApiService.removeFavoriteInr(payload);

      if (res.status) {
        updateFavState(row.symbol_name, false); 
      }
    } else {
      const res = await ApiService.addFavoriteInr(payload);

      if (res.status) {
        updateFavState(row.symbol_name, true);
      }
    }
  } catch (err) {
    console.log("Fav err:", err);
  }
};


   const handleUsdFavorite = async (row) => {
  try {
    // ✅ latest state value
    const currentItem = favoriteList.find(
      item => item.symbol_name === row.symbol_name
    );

    const isFav = currentItem?.isFav;

    const payload = {
      userid,
      symbolname: row.symbol_name,
      exch_seg: row.exch_seg,
    };

    if (isFav) {
      const res = await ApiService.removeFavoriteUsd(payload);
      if (res.status) {
        updateFavState(row.symbol_name, false);
      }
    } else {
      const res = await ApiService.addFavoriteUsd(payload);
      if (res.status) {
        updateFavState(row.symbol_name, true);
      }
    }
  } catch (err) {
    console.log("USD Fav err:", err);
  }
};



    return (
        <div className="container-fluid">
            <div className="card shadow-sm">

                {/* HEADER */}
                <div className="card-header">
                    <h5 className="card-title mb-0">Favorite List</h5>
                </div>
                <div className="card-body py-3">

                    {favoriteList.length === 0 ? (
                        <p className="text-muted text-center">No favorites found</p>
                    ) : (
                        favoriteList.map((item, index) => (
                            <div
                                key={item._id}
                                className="d-flex justify-content-between align-items-center border rounded px-3 py-2 mb-2"
                            >
                                {/* LEFT SIDE */}
                                <div>
                                    <div className="fw-semibold">{item.symbol_name}</div>
                                    <div className="text-muted small">
                                        <span>{item.tradesymbol}({item.exch_seg})</span>
                                    </div>
                                </div>

                                {/* RIGHT SIDE */}

                                <div
                                    onClick={() =>
                                        currency === "1"
                                            ? handleFavorite(item)      
                                            : handleUsdFavorite(item)   
                                    }

                                    style={{
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        transition: "0.2s",
                                    }}

                                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.15)")}
                                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                    title="Add to favourite"
                                >
                                    {item.isFav ? (
                                        <AiFillHeart style={{ color: "#ff3b3b" }} />
                                    ) : (
                                        <AiOutlineHeart style={{ color: "#b8b8b8" }} />
                                    )}
                                </div>

                            </div>
                        ))
                    )}

                </div>


            </div>
        </div>
    )
}

export default Favoriteslist